export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8948.98d61f18.jpg";